import { render, staticRenderFns } from "./BaoCommRecord.vue?vue&type=template&id=0c07d052&scoped=true&"
import script from "./BaoCommRecord.vue?vue&type=script&lang=js&"
export * from "./BaoCommRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07d052",
  null
  
)

export default component.exports